import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { __ } from '@design-system/i18n';
import { separatorShadow } from '@design-system/theme';
import { useProperty } from '../hooks/useProperty';
export const Header = forwardRef((_a, inputRef) => {
    var { children, id, isLoading, parentId, property = 'modal-head' } = _a, props = __rest(_a, ["children", "id", "isLoading", "parentId", "property"]);
    const ref = useRef(null);
    const height = useProperty(ref, 'dialog', parentId, property);
    const getHeaderElement = useCallback(() => ref.current, [ref]);
    const getHeaderHeight = useCallback(() => height, [height]);
    useImperativeHandle(inputRef, () => ({ getHeaderElement, getHeaderHeight }));
    return children || isLoading ? (_jsx(HeaderStyled, Object.assign({}, props, { id: id, ref: ref, children: isLoading ? __('Loading…') : children }))) : null;
});
const HeaderStyled = styled(Box).attrs(({ children }) => (Object.assign(Object.assign({}, (typeof children === 'string' && {
    as: 'h2',
    font: 'h3-semibold',
})), { height: 'min-content', m: 0, pl: { _: 4, m: 6 }, pr: 16, py: 6 }))) `
  grid-area: modal-head;
  ${({ $withShadow }) => $withShadow && separatorShadow}
  ${({ $withShadow }) => $withShadow && 'margin-bottom: 24px;'}
`;
//# sourceMappingURL=Header.js.map